/**
 * Observability utilities for HyperDX/ClickStack integration.
 *
 * Provides functions to identify users in session replays and traces.
 */

interface UserIdentity {
  userId: string;
  userEmail?: string;
  userName?: string;
  organizationId: string;
  organizationCode: string;
  userRole?: string;
}

/**
 * Set user identity for HyperDX session replay and traces.
 * Call this after successful login or when restoring auth from storage.
 */
export async function identifyUser(user: UserIdentity): Promise<void> {
  try {
    const HyperDX = await import('@hyperdx/browser');
    HyperDX.default.setGlobalAttributes({
      'user.id': user.userId,
      'user.email': user.userEmail || '',
      'user.name': user.userName || '',
      'organization.id': user.organizationId,
      'organization.code': user.organizationCode,
      'user.role': user.userRole || '',
    });
  } catch (err) {
    // HyperDX not available - silently ignore
    console.debug('HyperDX user identification skipped:', err);
  }
}

/**
 * Clear user identity on logout.
 */
export async function clearUserIdentity(): Promise<void> {
  try {
    const HyperDX = await import('@hyperdx/browser');
    HyperDX.default.setGlobalAttributes({
      'user.id': '',
      'user.email': '',
      'user.name': '',
      'organization.id': '',
      'organization.code': '',
      'user.role': '',
    });
  } catch (err) {
    // HyperDX not available - silently ignore
    console.debug('HyperDX identity clear skipped:', err);
  }
}
